// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-icon-icon-_7rnD {
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-left: auto;
  margin-right: 2px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/cell-icon/cell-icon.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".icon {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n  margin-left: auto;\n  margin-right: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `cell-icon-icon-_7rnD`
};
export default ___CSS_LOADER_EXPORT___;
